import React from "react";
import styles from "./Offer.module.css";

export default function Offer({ message = "" }) {
  const displayText = message.toUpperCase();

  return (
    <div className={styles.sectionContent}>
      <div className={styles.offer}>
        <p>
          {displayText}
        </p>
        <p>
          {displayText}
        </p>
        <p>
          {displayText}
        </p>
        <p>
          {displayText}
        </p>
      </div>
    </div>
  );
}
